import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { UserComponent }      from './components/user/user.component';
//import {LoginComponent } from './components/login/login.component';
import {LogoutComponent } from './components/logout/logout.component';
import {RegisterComponent } from './components/register/register.component';
//import { CustomerComponent } from './components/customer/customer.component';
//import { FeatureComponent } from './components/feature/feature.component';
//import { FeatureListComponent } from './components/feature-list/feature-list.component';
//import { CustomerListComponent } from './components/customer-list/customer-list.component';
//import { LicenseListComponent } from './components/license-list/license-list.component';
//import { LicenseComponent } from './components/license/license.component';
import { AboutComponent } from './components/about/about.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { RouteLabels } from './route-labels';
import { AuthGuardService } from './services/auth-guard.service';

// Import Containers
import { FullLayoutComponent, SimpleLayoutComponent } from './containers';
import { LoginComponent } from 'app/components/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  { path: RouteLabels.LOGIN, component: LoginComponent },
  { path: RouteLabels.REGISTER, component: RegisterComponent },
  //{ path: RouteLabels.USER, component: UserComponent },
  //{ path: RouteLabels.LICENSE_LIST, component: LicenseListComponent },
  //{ path: RouteLabels.LICENSE, component: LicenseComponent },
  //{ path: RouteLabels.CUSTOMER_LIST, component: CustomerListComponent, canActivate: [AuthGuardService] },
  //{ path: RouteLabels.CUSTOMER, component: CustomerComponent },
  //{ path: RouteLabels.FEATURE_LIST, component: FeatureListComponent },
  //{ path: RouteLabels.FEATURE, component: FeatureComponent },
  { path: RouteLabels.ABOUT, component: AboutComponent },
  { path: RouteLabels.CONTACTUS, component: ContactUsComponent },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'licenses',
        loadChildren: './components/license-list/license-list.module#LicenseListModule',
        canActivate: [AuthGuardService]
      },
      {
        path: 'customers',
        loadChildren: './components/customer-list/customer-list.module#CustomerListModule',
        canActivate: [AuthGuardService]
      },
      {
        path: 'features',
        loadChildren: './components/feature-list/feature-list.module#FeatureListModule',
        canActivate: [AuthGuardService]
      },
      {
        path: 'changelogs',
        loadChildren: './components/change-log-list/change-log-list.module#ChangeLogListModule',
        canActivate: [AuthGuardService]
      },
      {
        path: 'resetcloudpassword',
        loadChildren: './components/reset-cloud-password/reset-cloud-password.module#ResetCloudPasswordModule',
        canActivate: [AuthGuardService]        
      }
    ]
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout'
    }
  },
  // {
  //   path: 'register',
  //   component: RegisterComponent,
  //   data: {
  //     title: 'Register'
  //   }
  // },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts